<div class="flex-column-layout confirmation-dialog" [ngClass]="details.windowClass">

  <div [ngClass]="details.headerClass">{{details.header}}</div>

  <div [ngClass]="details.contentClass">{{details.text}}</div>

  <div [ngClass]="details.footerClass">
    <div [ngClass]="details.buttonsReverse === false ? 'flex-row-layout justify-content-end' : 'flex-reverse-row-layout justify-content-start'">
      <div class="flex-column-layout justify-content-center">
        <button [ngClass]="details.cancelButtonClass"
          (click)="submit(false)">{{details.cancelButtonText}}
        </button>
      </div>
      <div class="flex-column-layout justify-content-center mar-5-right">
        <button [ngClass]="details.okButtonClass"
          (click)="submit(true)">
          {{details.okButtonText}}
        </button>
      </div>
    </div>
  </div>

</div>
